import { Context as ResponsiveContext } from 'react-responsive';
import { IChildrenProps } from '../../models/utilTypes';
import StyledLayoutGapManager from './StyledLayoutGapManager';

interface IRightRailProps extends IChildrenProps {
  width?: number;
}

const RightRail: React.FC<IRightRailProps> = ({ children, width = 375 }) => (
  <ResponsiveContext.Provider value={{ width }}>
    <StyledLayoutGapManager className="right-rail">
      {children}
    </StyledLayoutGapManager>
  </ResponsiveContext.Provider>
);

export default RightRail;
